import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _typeof from "@babel/runtime/helpers/typeof";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @file index.ts
 * @author markJia(markjia@tencent.com)
 */
import { Emitter } from '@tencent/glue-util-emitter';
export var createTypedMap = function createTypedMap(list, key) {
  var result = {};

  var _iterator = _createForOfIteratorHelper(list),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var k = key ? item[key] : item;
      var tKey = "".concat(_typeof(k), "-").concat(k);
      result[tKey] = item;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
};
export var getTypedKey = function getTypedKey(key) {
  return "".concat(_typeof(key), "-").concat(key);
};
export var Tabs = /*#__PURE__*/function (_Emitter) {
  _inherits(Tabs, _Emitter);

  var _super = _createSuper(Tabs);

  function Tabs(ops) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this);
    _this.disabled = false;
    _this.index = 0;
    _this.tabItemMap = new Map();
    _this.tabItemList = [];
    _this.closable = false;
    _this.activeId = ops.activeId;
    return _this;
  }

  _createClass(Tabs, [{
    key: "getActiveId",
    value: function getActiveId() {
      return this.activeId;
    }
  }, {
    key: "getTabItemMap",
    value: function getTabItemMap() {
      return this.tabItemMap;
    }
  }, {
    key: "updateActiveId",
    value: function updateActiveId(id) {
      var need = this.needUpdate(id);

      if (need) {
        this.emit('active-id-change', id);
      }
    }
  }, {
    key: "updateTabsOptions",
    value: function updateTabsOptions(_ref) {
      var value = _ref.value,
          disabled = _ref.disabled,
          closable = _ref.closable;
      var need = this.needUpdate(value);

      if (this.disabled !== disabled || this.closable !== closable) {
        this.disabled = disabled;
        this.closable = closable;
        need = true;
      }

      if (need) {
        this.activeId = value;
        this.updateTabItems();
      }
    }
  }, {
    key: "getClosable",
    value: function getClosable() {
      return this.closable;
    }
  }, {
    key: "registerTabItem",
    value: function registerTabItem(item) {
      var insId = item.getInsId();

      if (this.tabItemMap.has(insId)) {
        throw new Error("insId=".concat(insId, " id=").concat(item.getId(), " tabItem have been registered"));
      }

      this.tabItemMap.set(insId, item);
      this.updateTabItemList();
      this.emit('tabs-header-change');
    }
  }, {
    key: "updateTabItemList",
    value: function updateTabItemList() {
      this.tabItemList = _toConsumableArray(this.tabItemMap.values());
    }
  }, {
    key: "getTabItemList",
    value: function getTabItemList() {
      return this.tabItemList;
    }
  }, {
    key: "unRegisterTabItem",
    value: function unRegisterTabItem(item) {
      var insId = item.getInsId();

      if (!this.tabItemMap.has(insId)) {
        throw new Error("insId=".concat(insId, " id=").concat(item.getId(), " tabItem have been unregistered"));
      }

      this.tabItemMap.delete(insId);
      this.updateTabItemList();
      this.emit('tabs-header-change');
    }
  }, {
    key: "isActive",
    value: function isActive(id) {
      return this.activeId === id;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      Object.values(this.tabItemMap).forEach(function (item) {
        return item.dispose();
      });
    }
  }, {
    key: "getItemIndex",
    value: function getItemIndex() {
      this.index++;
      return this.index;
    }
  }, {
    key: "needUpdate",
    value: function needUpdate(id) {
      var need = false;

      if (id !== this.activeId) {
        need = true;
      }

      return need;
    }
  }, {
    key: "updateTabItems",
    value: function updateTabItems() {
      _toConsumableArray(this.tabItemMap.values()).forEach(function (item) {
        return item.refreshItem();
      });
    }
  }]);

  return Tabs;
}(Emitter);